import { MapPin, Mail, Phone, Globe } from "lucide-react";
import madeThereLogo from "@/assets/madethere-logo.svg";

const Footer = () => {
  return (
    <footer className="bg-secondary/50 border-t border-border py-12 px-4 sm:px-6">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Company Info */}
          <div className="space-y-6">
            <img src={madeThereLogo} alt="Made There Software Factory" className="h-14 sm:h-16 w-auto" />
            <p className="text-sm sm:text-base text-muted-foreground max-w-md">
              Made There Software Factory - Expertos en desarrollo de soluciones de Inteligencia Artificial
              Conversacional para empresas.
            </p>
          </div>
          
          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-lg sm:text-xl font-bold text-primary">Contáctanos</h3>
            <div className="space-y-4">
              <a
                href="https://maps.google.com/?q=Echeverría+647+of.+702,+Montevideo,+Uruguay"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors group"
              >
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5 group-hover:text-primary" />
                <span>Echeverría 647 of. 702, Montevideo, Uruguay</span>
              </a>
              
              <a
                href="mailto:info@madethere.com.uy"
                className="flex items-center gap-3 text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors group"
              >
                <Mail className="h-5 w-5 group-hover:text-primary" />
                <span>info@madethere.com.uy</span>
              </a>
              
              <a
                href="tel:+59899663202"
                className="flex items-center gap-3 text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors group"
              >
                <Phone className="h-5 w-5 group-hover:text-primary" />
                <span>+598 99 663202</span>
              </a>
              
              <a
                href="https://www.madethere.com.uy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors group"
              >
                <Globe className="h-5 w-5 group-hover:text-primary" />
                <span>www.madethere.com.uy</span>
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-muted-foreground">
              © {new Date().getFullYear()} Made There Software Factory. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4 sm:gap-6 text-xs sm:text-sm">
              <a href="#terminos" className="hover:text-primary transition-colors">
                Términos y Condiciones
              </a>
              <a href="#privacidad" className="hover:text-primary transition-colors">
                Política de Privacidad
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
